import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from 'swiper'; 
Swiper.use([Thumbs, Navigation, Pagination, Autoplay]);

export default class BasicSlider {
    constructor(el) {
        if (!this.set(el)) return;
        this.init(); 
    }

    set(el) {
        if (!el) return false;
        this.slider = el;
        this.sliderEl = this.slider.querySelector('[data-swiper-slider-swiper]');
        this.pagination = this.slider.querySelector('[data-swiper-slider-pagination]');
        this.prev = this.slider.querySelector('[data-swiper-slider-prev]');
        this.next = this.slider.querySelector('[data-swiper-slider-next]');
        this.swiper = null;

        return true;
    }

    init() {
        const navigation = (this.prev && this.next) ? {
            prevEl: this.prev,
            nextEl: this.next,
        } : {}

        this.swiper = new Swiper(this.sliderEl, {
            slidesPerView: 'auto',
            centeredSlides: true,
            // loop: true,
            navigation,
        });
    }
}